var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificateDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000671387,
    y: -0.00012207,
    width: 33,
    height: 33,
    rx: 9,
    fill: "#01C670"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7212 7.99988C17.353 7.99988 17.8653 8.51211 17.8653 9.14398V17.0601L20.4886 14.4369C20.9354 13.9901 21.6597 13.9901 22.1065 14.4369C22.5533 14.8837 22.5533 15.608 22.1065 16.0548L17.5301 20.6312C17.3156 20.8458 17.0246 20.9663 16.7212 20.9663C16.4178 20.9663 16.1267 20.8458 15.9122 20.6312L11.3358 16.0548C10.889 15.608 10.889 14.8837 11.3358 14.4369C11.7826 13.9901 12.507 13.9901 12.9538 14.4369L15.5771 17.0601V9.14398C15.5771 8.51211 16.0893 7.99988 16.7212 7.99988Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00067 24.3993C9.00067 23.7675 9.51291 23.2552 10.1448 23.2552H22.3485C22.9803 23.2552 23.4926 23.7675 23.4926 24.3993C23.4926 25.0312 22.9803 25.5434 22.3485 25.5434H10.1448C9.51291 25.5434 9.00067 25.0312 9.00067 24.3993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateDownload);
export default __webpack_public_path__ + "static/media/certificate_download.3f473eaa42c6a287c02b9274a6630e2c.svg";
export { ForwardRef as ReactComponent };